import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import CalendarioV2Service from '../../services/calendarioV2.service';
import { useTheme } from '@mui/material/styles';

const SelectCanalesCalendar = ({id, value, onChange, isInvalid, isClearable, isMulti,disabled}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    
    const [options, setOptions] = useState([]);
    const [items, setItems] = useState([]);
    const [selectedValue, setSelectedValue] = useState();
    const actualizar = async() =>{
        await CalendarioV2Service.canalesCalendar().then((resp)=>{
            setItems(resp)
        })
        .catch((err)=>{
            setItems([])
        })
    }

    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        if(ev){
            onChange(ev);
        } else {
            onChange(null);
        }
    };

    useEffect(() => {
        if(items.length > 0){
            const newOptions = items?.map((item) => {
                return { ...item, value: item.id, label: item.nombre };
            });
            setOptions(newOptions);
        }else{
            setOptions([])
        }
    }, [items]);

    useEffect(() => {
        if( options.length > 0 ){
            if(typeof value === 'string' || typeof value === 'number'){
                setSelectedValue(
                    options.find((opt) => opt.value === Number(value))
                );
            }else if(Array.isArray(value)){
                setSelectedValue(value.map(va=>{
                    const item = items.find(it=>it.id === va);
                    if(item){
                        return {
                            value:item.id,
                            label:item.nombre
                        };
                    }
                    return null
                }))
            }
        }
    }, [options,value])
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (provided) => ({
            ...provided,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected 
                ? (isDarkMode ? '#90caf9' : '#fff') 
                : (isDarkMode ? '#e0e0e0' : '#000'),
            background: state.isSelected 
                ? (isDarkMode ? '#1a3a5c' : '#0364ff') 
                : (isDarkMode ? '#2d3a52' : '#fff'),
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: isDarkMode ? '#e0e0e0' : '#e0e0e0',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: isDarkMode ? '#1a3a5c' : '#0364ff',
                borderRadius: 5,
                border: isDarkMode ? '1px solid #fff' : 'none',
                border: isDarkMode ? '1px solid #fff' : 'none',
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: '#fff',
            },
        }),
        control: (styles) => ({
            ...styles,
            borderRadius: 7,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        singleValue: (styles) => ({
            ...styles,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        input: (styles) => ({
            ...styles,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        placeholder: (styles) => ({
            ...styles,
            color: isDarkMode ? '#b0bec5' : 'gray',
        }),
    }), [isDarkMode])
    useEffect(() => {
        actualizar()
    }, [])
    return (
        <Select
            isDisabled={disabled}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
            isMulti={isMulti}
        />
    );
};

SelectCanalesCalendar.defaultProps = {
    isClearable: false
};

export default SelectCanalesCalendar

